export default __webpack_public_path__ + "static/media/KIMS.f9b452d4.png";